import Column from "@/components/Column";
import Form from "@/components/Form";

import Button from "@/components/Button";
import Columns from "@/components/Columns";
import ErrorText from "@/components/ErrorText";
import SEO from "@/components/SEO";
import ShortFlowLayout from "@/components/ShortFlow/ShortFlowLayout";
import Text from "@/components/Text";
import VerificationCode from "@/components/VerificationCode";
import { useShortFlowSMSConfirmation } from "./hooks/useShortFlowSMSConfirmation";

// Confirm SMS Fields
export const ShortConfirmSMS = () => {
  const {
    phoneNumber,
    clearVerificationCode,
    SMSConfirmationLoading,
    error,
    timer,
    sendSMSIsLoading,
    smsSentConfirmation,
    maskedPhone,
    pageConfig,
    handleOnSubmit,
    handleTokenResend,
    setSmsCode,
    handleOnChange,
    handleOnComplete,
  } = useShortFlowSMSConfirmation();
  return (
    <ShortFlowLayout>
      <SEO
        title="Validação de SMS"
        description="Confirme o seu número com o token enviado"
      />

      <Columns as={Form} onSubmit={handleOnSubmit} justifyContent="center">
        <Column
          size={12}
          className="pb-8 text-center lg:pl-6"
          data-ic-title="sec-omega-comunicacao"
        >
          <Text kind="blue" size="base" className="text-left">
            Show!
          </Text>
          <Text kind="blue" size="base" className="text-left lg:mt-8">
            Para sua segurança e para confirmar seu pedido, preencha o código de
            segurança que enviamos por SMS e WhatsApp para o número {phoneNumber}
          </Text>
        </Column>

        <Column size={[12, 10]} className="pb-4 text-center">
          {smsSentConfirmation && (
            <p className="mb-4 rounded bg-green-100 px-4 py-2 text-sm text-green-800">
              SMS enviado para o número {maskedPhone}
            </p>
          )}
          <VerificationCode
            fieldsCount={4}
            onChange={(e) => {
              setSmsCode(e);
              handleOnChange();
            }}
            onComplete={handleOnComplete}
            clear={clearVerificationCode}
            disabled={SMSConfirmationLoading}
          />
          {error && (
            <ErrorText showIcon={false} id="verification-error">
              {error}
            </ErrorText>
          )}
        </Column>

        {timer === 0 ? (
          <Column size={12} className="pb-1 text-center">
            <Button
              kind="secondary"
              onClick={handleTokenResend}
              loading={sendSMSIsLoading}
            >
              <span className="flex leading-normal">Reenviar Código</span>
            </Button>
          </Column>
        ) : (
          <Column
            size={12}
            className="pb-10 text-center font-normal text-blue-400"
          >
            Outro token poderá ser gerado em {timer} segundos
          </Column>
        )}

        <Column size={12} />

        <Column size={12}>
          <Button
            type="button"
            kind="secondary"
            large
            to={pageConfig.prevRoute}
            data-ic-trigger="sec-omega-voltar"
          >
            Voltar
          </Button>
        </Column>
      </Columns>
    </ShortFlowLayout>
  );
};

export default ShortConfirmSMS;
